module.exports = __webpack_public_path__ + "img/Cover_HW_21.30ca204d.jpg";